import React from 'react';
import './Clouds.css'; // Import the CSS file for styling

const Cloud = () => {
  return (
    <div className="cloud-right">
      <div className="circle-right big-right"></div>
      <div className="circle-right medium-right"></div>
      <div className="circle-right small-right"></div>
    </div>
  );
};

export default Cloud;
